module.exports = __webpack_public_path__ + "static/Opendays-30c3da7f8406e50284a720b8b13a6d99.png";